define('SageDotCom/Components/ProductCard/ProductCardSelection',['jquery', "eventManager"], function($, eventManager) {

    function ProductCardSelection() { }

    ProductCardSelection.prototype.checkPageCookie = function checkPageCookie() {
        if (!this.checkProductCardPersonalisationEnabled())
            return;

        const pathName = window.location.pathname;

        //read out cookie value and set the product card
        let cookieValue = getCookie(`${pathName}_productCardSelection`);
        if(cookieValue != null) {   
            let obj = JSON.parse(cookieValue);
            for (const card in obj) {
                const $card = $(`.sage-product-card[data-pid='${card}'], .sage-product-card-alt[data-pid='${card}']`);
                let objectValues = obj[card];
                if (objectValues.dropdownIndex != null) {

                    setTimeout(function () {
                        $card.find('.sage-product-card-tooltip-icon').each(function () {
                            $(this).tooltip('destroy');
                        });
                    }, 10);

                    $card.find(".price-ddl").prop('selectedIndex',objectValues.dropdownIndex);
                    const cardContainer = $card.parent().attr("id");

                    eventManager.trigger('productCardPriceChange:' + cardContainer, $("#" + cardContainer));
                    eventManager.trigger("product card detail event", "dropdown", "", false, "", objectValues.dropdownIndex);

                    setTimeout(function () {
                        $card.find('.sage-product-card-tooltip tr').each(function () {
                            if ($(this).find('span').is(':empty')) {
                                $(this).css('display', 'none');
                            } else {
                                $(this).css('display', '');
                            }
                        });

                        $card.find('.sage-product-card-tooltip-icon').each(function () {
                            $(this).tooltip(
                                {
                                    html: true,
                                    placement: 'bottom',
                                    title: $('#' + $(this).data('tip')).html()
                                });
                        });

                    }, 500);
                }
                if (objectValues.checkboxSelected == true) {
                    
                    //this if is to prevent issue with when the user clicks back in browser and the checkbox is selected
                    if(!$card.find(".addon-chk").is(":checked")) {
                        $card.find(".addon-chk").click();
                    }

                }
            }
        } 
    }
    
    ProductCardSelection.prototype.setProductCardValue = function setProductCardValue(part, value, productCardId) {
        if (!this.checkProductCardPersonalisationEnabled())
            return;

        const pathName = window.location.pathname;
        const dateTime = new Date();
        let cookieValue = getCookie(`${pathName}_productCardSelection`);
        let cardSelections = {};
        dateTime.setTime(dateTime.getTime() + (7*24*60*60*1000));
        const expires = "expires="+ dateTime.toUTCString();

        let cardSelection = {
            dropdownIndex: null,
            checkboxSelected: false
        }

        //check if already saved
        if (cookieValue == null) {
            //check if value for dropdown has been saved
            if (part == "dropdown") {
                cardSelection.dropdownIndex = value;
            } else {
                cardSelection.checkboxSelected = value;
            }

            //append key value pair to the object
            Object.assign(cardSelections, {[productCardId]: cardSelection})

            document.cookie = `${pathName}_productCardSelection=${JSON.stringify(cardSelections)};${expires};path=/`;
        } else {
            let obj = JSON.parse(cookieValue);
            let currentProductCard = obj[productCardId];

            //this will update the object
            if (part == "dropdown") {
                if (currentProductCard == null) {
                    cardSelection.dropdownIndex = value;
                    Object.assign(obj, {[productCardId]: cardSelection})
                } else {
                    if (currentProductCard.dropdownIndex != value) {
                        currentProductCard.dropdownIndex = value;
                    }
                }
            } else {
                if (currentProductCard == null) {
                    cardSelection.checkboxSelected = value;
                    Object.assign(obj, {[productCardId]: cardSelection})
                } else {
                    if (currentProductCard.checkboxSelected != value) {
                        currentProductCard.checkboxSelected = value;
                    }
                }
            }
            //override the cookie with updated values
            document.cookie = `${pathName}_productCardSelection=${JSON.stringify(obj)};${expires};path=/`;
        }
    } 

    ProductCardSelection.prototype.checkProductCardPersonalisationEnabled = function checkProductCardPersonalisationEnabled() {
        return document.body.classList.contains('pc-personalisation');
    }

    const getCookie = (cname) => {
        let ca = document.cookie.split(";");
        
        for (const cookie of ca) {
            if (cookie.indexOf(cname + "=") > 0) {
                return cookie.split("=")[1];
            }
        }
        return null;
    };

    return new ProductCardSelection();
});
